import { StyleSheet, TouchableOpacity, View, TouchableWithoutFeedback } from "react-native";
import { fp, hp, spV, wp } from "utils/normalise";
import { useRef } from "react";

import { Colors } from "colors";
import { Image } from "react-native";
import { ORDERING_CHANNEL } from "utils/Constants";
import React from "react";
import { Svg } from "assets/svg";
import VText from "components/VText";
import { useSelector } from "react-redux";
import { useState, useEffect } from "react";


const SavedCardsComp = (props) => {
    const { item, onPressCard, selectedCard } = props;
    const [showDelete, setShowDelete] = useState(false);
    const deleteRef = useRef(null);




    const onPressDelete = (id) => {
        onPressCard(id);
        setShowDelete(false);

    };

    const getCardIcon = (cardType) => {
        switch (cardType) {
            case "Visa":
                return Svg.visaIcon;
            case "MasterCard":
                return Svg.mastercardIcon;
            case "AmericanExpress":
                return Svg.amexIcon;
            case "DinersClub":
                return Svg.dinersIcon;
            case "Discover":
                return Svg.discoverIcon;
            case "JCB":
                return Svg.jcbIcon;
            default:
                return Svg.creditCard;
        }
    }





    const toggleDelete = () => {
        setShowDelete(!showDelete);
    };

    const handleOutsideClick = (event) => {
        if (showDelete && deleteRef.current && !deleteRef.current.contains(event.target)) {
            setShowDelete(false);
        }
    };

    return (            
            <TouchableOpacity activeOpacity={0.8} onPress={() => onPressCard(item)}>
                <View style={selectedCard === item ? Styles.selectedCardContainer : Styles.cardContainer}>
                    <Image accessibilityLabel="Card Icon" resizeMode="contain" style={Styles.cardImage} source={getCardIcon(item?.cardType)} />
                    <View>
                        <VText style={Styles.cardNumber}>xxxx xxxx xxxx {item.mask}</VText>
                        <VText style={Styles.cardName}>
                            {item?.name} {item?.isSecure ? "| Secured" : ""}
                        </VText>
                    </View>
                    {/* <View style={{ marginLeft: "auto", paddingTop: wp(16) }}>
                        <TouchableOpacity onPress={toggleDelete}>
                            <Image accessibilityLabel="Three Dots" resizeMode="contain" style={Styles.threeDots} source={Svg.threeDots} />
                        </TouchableOpacity>
                        {showDelete && (
                            <TouchableOpacity ref={deleteRef} activeOpacity={1} style={Styles.deleteButtonOverlay} onPress={() => onPressDelete(item)}>
                                <VText style={Styles.deleteButton}>Delete</VText>
                            </TouchableOpacity>
                        )}
                    </View> */}
                </View>
            </TouchableOpacity>

    );
};
export default SavedCardsComp;

const Styles = StyleSheet.create({
    cardImage: {
        width: wp(40),
        height: hp(40),
        marginRight: wp(10),
        padding: spV(8),
    },
    cardNumber: {
        fontSize: fp(20),
        fontWeight: "350",
        color: "#333333",
    },
    cardName: {
        fontSize: fp(16),
        fontWeight: "400",
        color: "#21242799",
        marginTop: spV(4),
    },

    selectedCardContainer: {
        paddingVertical: spV(10),
        paddingHorizontal: wp(10),
        flexDirection: "row",
        borderWidth: 1,
        // paddingBottom: spV(10),
        marginBottom: spV(10),
        borderColor: "rgba(223, 223, 223, 1)",
        width: wp(450),
        borderColor: "black",
        borderRadius: wp(5),
    },

    
    cardContainer: {
        paddingVertical: spV(10),
        paddingHorizontal: wp(10),
        flexDirection: "row",
        borderWidth: 1,
        // paddingBottom: spV(10),
        marginBottom: spV(10),
        borderColor: "rgba(223, 223, 223, 1)",
        width: wp(450),
        borderColor: "#00000033",
        borderRadius: wp(5),
    },
    deleteButton: {
        position: "absolute",
        backgroundColor: "white",
        paddingHorizontal: wp(15),
        paddingVertical: spV(5),
        boxShadow: "0px 0px 10px 0px rgba(0, 0, 0, 0.1)",
        top: hp(8),
        right: -wp(40),
        fontSize: fp(14),
        fontWeight: "350",
        color: Colors.black,
    },
});
